import { ProposalResponseModel } from "../../helpers/proposalResponse";
import { PolicyStore } from "../../stores/policyStore";
import { WidgetApiService } from "./widgetApiService";
import { action, computed, observable } from "mobx";
import { DefaultRequestStatus, RequestStatus } from "./requestStatus";


export interface PolicyService {
  requestPolicy: (proposalId: ProposalResponseModel) => Promise<any>;
  getPolicyRenewalDataRequestStatus: RequestStatus;
  getPolicyRenewalDataRequest: (authorizedPolicyRenewalOfferId: string) => Promise<{ series: string, number: string, peselOrRegon: string }>;
  reset: () => void;
}

export class DefaultPolicyService implements PolicyService {

  constructor(private policyStore: PolicyStore, private widgetSrvc: WidgetApiService) { }

  public async requestPolicy(proposalId: ProposalResponseModel): Promise<any> {
    return await this.policyStore.policyRequestStatus.handleRequest(
      () => this.widgetSrvc.policy(proposalId)
    );
  }

  @observable
  private _getPoliceRenewalDataRequest: RequestStatus = new DefaultRequestStatus();

  @computed
  public get getPolicyRenewalDataRequestStatus(): RequestStatus {
    return this._getPoliceRenewalDataRequest;
  }

  @action
  public async getPolicyRenewalDataRequest(authorizedPolicyRenewalOfferId: string) {
    return await this.getPolicyRenewalDataRequestStatus.handleRequest(
      () => this.widgetSrvc.getPolicyRenewalData(authorizedPolicyRenewalOfferId)
    );
  }

  @action
  public reset() {
    this._getPoliceRenewalDataRequest = new DefaultRequestStatus();
  }
}